import { Component } from '@angular/core';

@Component({
  selector: 'app-embed-example',
  standalone: true,
  templateUrl: './embed-example.component.html',
  styleUrl: './embed-example.component.scss',
})
export class EmbedExampleComponent {}
